import { BindingObject, DataPropInfo, DataTypeInfo, ViewModel } from '@farris/devkit';
import { isNumber } from 'lodash-es';
/**
 * å¸®å©æ å°åºç±»
 */
export class DataMapping {
  public vm: ViewModel;
  public target: BindingObject;
  /**
   * å¤éå¸®å©é»è®¤åéç¬¦
   */
  protected readonly defaultSpliter = ',';
  /**
   * æ å°æ°æ®
   * @param helpData æ¸ç©ºæ¶ï¼å¼ä¸ºnull
   * @param mapFields æ ¼å¼å½¢å¦ï¼{id: "assoField.assoField", code: "assoField.assoField_Code", name: "assoField.assoField_Name"}
   * @param asClear ç±»ä¼¼æ¸ç©º
   * @param [spliter=','] å¤éåéç¬¦
   */
  mappingData(helpData: any, mapFields: any, asClear: boolean = false, spliter: string = ',') {
    if (!mapFields) {
      return;
    }
    // å³é­åæ´æ£æµ
    const appContext = this.vm.frameContext.appContext;
    appContext.changeDetectionController.detach();
    let helpFields = Object.keys(mapFields);
    const basePaths = this.getBindingPathArray();
    const primaryInfo = this.getMapFieldsPrimaryKey(mapFields, basePaths);
    // æ å°å°ç®æ ä¸»é®çæºå­æ®µæ°ç»
    const primaryKeys: string[] = primaryInfo && primaryInfo.map((item) => item.primaryKey) || [];
    // ç®æ ä¸»é®å­æ®µæ°ç»
    const primaryFields: string[] = primaryInfo && primaryInfo.map((item) => item.primaryField) || [];
    // å¯¹æ å°ä¸­çkeyè¿è¡æåºï¼ä½¿æ å°å°ç®æ ä¸»é®çkeyæå°åé¢
    helpFields = this.sortMapFieldKeys(helpFields, primaryKeys);
    if (!helpData || asClear) {
      helpFields.reverse();
    }
    this.mapping(helpFields, mapFields, helpData, primaryFields, basePaths, asClear, spliter);
    // éæ°æå¼åæ´æ£æµ
    appContext.changeDetectionController.reattach();
  }
  private mapping(sortedKeyFields: string[], mapFields: any, helpData: any, targetPrimaryFields: string[], basePaths: string[], asClear: boolean = false, spliter = ',') {
    sortedKeyFields.forEach((field: any) => {
      const val = this.getHelpValue(field, helpData, spliter);
      let mappings: any[] = mapFields[field].split(',');
      const headMappings = mappings.filter((p) => targetPrimaryFields.includes(p));
      const leftMappings = mappings.filter((p) => !targetPrimaryFields.includes(p));
      if (!helpData || asClear) {
        mappings = [].concat(leftMappings).concat(headMappings);
      } else {
        mappings = [].concat(headMappings).concat(leftMappings);
      }
      this.updateTarget(mappings, basePaths, helpData, val);
    });
  }
  private updateTarget(mappings: string[], basePaths: string[], helpData: any, value: any) {
    mappings.forEach((targetFieldPath: any) => {
      this.updateTargetValue(basePaths, targetFieldPath, value, helpData);
    });
  }
  private updateTargetValue(basePaths: string[], targetFieldPath, value: any, helpData: any) {
    if (this.target) {
      const paths = targetFieldPath.split('.');
      this.setValue(this.target, paths, value);
    } else {
      const paths = basePaths.concat(targetFieldPath.split('.'));
      if (!helpData) {
        this.vm.bindingData.clearValue(paths, true, true, { frameContext: this.vm.frameContext });
      } else {
        this.vm.bindingData.setValue(paths, value, true, true, null, { frameContext: this.vm.frameContext });
      }
    }
  }
  /**
   * è·åå¸®å©å­æ®µå¯¹åºçå¼
   * @param field å¸®å©å­æ®µ
   * @param helpData å¸®å©æ°æ®
   * @param [spliter=','] å¤éå¸®å©åéç¬¦
   * @returns
   */
  private getHelpValue(field: string, helpData: any, spliter = ',') {
    let value: any = '';
    if (helpData) {
      if (helpData instanceof Array) {
        value = helpData.map((item: any) => {
          return this.getValue(field, item);
        }).join(spliter);
      } else {
        value = this.getValue(field, helpData);
      }
    }
    return value;
  }
  protected getValue(f: string, data: any) {
    let val = '';
    if (f.indexOf('.') === -1) {
      val = data[f];
    } else {
      val = f.split('.').reduce((a, b) => {
        return a[b];
      }, data);
    }

    return val;
  }
  protected setValue(target: object, paths: string[], value: any) {
    if (target) {
      if (paths.length <= 1) {
        target[paths[0]] = value;
      } else {
        paths.slice(0, -1).reduce((prev, path) => {
          if (!(prev.hasOwnProperty(path) || prev['__proto__'].hasOwnProperty(path))) {
            prev[path] = {};
          }
          return prev[path];
        }, target)[paths[paths.length - 1]] = value;
      }
    }
  }
  private getBindingPathArray(): any[] {
    const path = this.vm.bindingPath;
    if (path) {
      return path.split('/').filter((n) => n !== '');
    }
    return [];
  }

  private isNumberValue(field, data) {
    const currentVal = this.getValue(field, data);
    return isNumber(currentVal);
  }
  /**
   *
   * @param mapFields  æ ¼å¼å½¢å¦ï¼{id: "assoField.assoField", code: "assoField.assoField_Code", name: "assoField.assoField_Name"} æè {id:'vid',code:'code',name:'name'}
   */
  private getMapFieldsPrimaryKey(mapFields: any, bindingPaths: string[]): Array<{ primaryKey: string, primaryField: string }> {
    if (!mapFields || Object.keys(mapFields).length < 1) {
      return null;
    }
    const results = [];
    // let primaryField = null;
    try {
      const entityTypeInfo: DataTypeInfo = this.vm.frameContext.repository.entityTypeInfo;
      Object.keys(mapFields).forEach((key: string) => {
        const mapField = mapFields[key];
        if (mapField && typeof mapField === 'string') {
          const mappings = mapField.split(',').filter((p) => p);
          mappings.forEach((item: string) => {
            let paths = item.split('.');
            if (bindingPaths && bindingPaths.length > 0) {
              paths = bindingPaths.concat(paths);
            }
            const propInfo: DataPropInfo = entityTypeInfo.getPropInfoByPath(paths);
            if (propInfo && propInfo.metadataInfo && propInfo.metadataInfo.primary === true) {
              results.push({
                primaryKey: key,
                primaryField: item
              });
            }
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
    return results;
  }
  private sortMapFieldKeys(keys: string[], primaryKeys: string[]): string[] {
    if (!primaryKeys || primaryKeys.length < 1 || !keys || keys.length < 1) {
      return keys;
    }
    primaryKeys = [...new Set(primaryKeys)];
    // è¿æ»¤åºéä¸»é®æ å°å­æ®µ
    keys = keys.filter((p) => !primaryKeys.includes(p));
    return [].concat(primaryKeys).concat(keys);
  }
}
